module.exports = __webpack_public_path__ + "static/media/card-icon.5c3ae50a.svg";